import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_DEAL_CLIENTS } from '@/lib/constants/api'
import getDealClientModel from './models/dealClient'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const dealClient = {
  namespaced: true,
  state: {
    ...getDealClientModel()
  },
  getters: {
    getField,
    getDealClientObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    updateStatus,
    setDealClient: (state, client) => {
      state.id = client.id
      state.dealId = client.dealId
      state.existingClientId = client.existingClientId
      state.name = client.name
      state.invoiceFrequencyId = client.invoiceFrequencyId
      state.invoiceFrequencyName = client.invoiceFrequencyName
      state.thirdPartyPortalId = client.thirdPartyPortalId
      state.vmsFee = client.vmsFee
      state.contractorExpenses = client.contractorExpenses
      state.directPlacementsExpenses = client.directPlacementsExpenses
    },
    clearDealClient: (state) => {
      state.id = null
      state.dealId = null
      state.clientType = null
      state.existingClientId = null
      state.name = null
      state.invoiceFrequencyId = null
      state.invoiceFrequencyName = null
      state.thirdPartyPortalId = null
      state.vmsFee = null
      state.contractorExpenses = null
      state.directPlacementsExpenses = null
    }
  },
  actions: {
    save ({ state }) {
      return api.doPost({ path: PATH_DEAL_CLIENTS, data: state })
    },
    update ({ state }) {
      return api.doPut({ path: PATH_DEAL_CLIENTS, data: state })
    },
    getDealClient: ({ commit, dispatch }, { dealId }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting client, please wait...' })

      return api.doGet({ path: PATH_DEAL_CLIENTS, parameters: { dealId } })
        .then(json => json.data)
        .then(data => Array.isArray(data) ? data[0] : data)
        .then(client => {
          commit('updateStatus', { status: COMPLETE })
          commit('clearDealClient')
          commit('setDealClient', client)
          return client
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveDealClient: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving client, please wait...' })

      const actionName = state.id ? 'update' : 'save'

      return dispatch(actionName).then(response => {
        commit('updateStatus', { status: COMPLETE })

        if (!response.data) {
          throw new Error('Unable to save client. Check required fields.')
        }

        notifySuccess(dispatch, 'Client saved')
        commit('setDealClient', response.data)
        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        notifyError(dispatch, 'Unable to save client. Try again later')

        throw error
      })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    clearDealClient: ({ commit }) => {
      commit('clearDealClient')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default dealClient
